// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A0ROz","footer":"styles_footer__R8SO+","spacer":"styles_spacer__7P1xV"};